import React, { useEffect } from 'react'
import '@mantine/core/styles.css'
import '@mantine/carousel/styles.css'
import '@mantine/tiptap/styles.css'
import '../styles/globals.scss'
import '../styles/v2/app.css'
import '../styles/base/fonts.scss'
import 'react-toastify/dist/ReactToastify.css'
import * as ga from '../shared/utils/ga'
import { useRouter } from 'next/router'
import { AppProviders } from '../_providers/_providers'
import NextNProgress from 'nextjs-progressbar'
import { vars } from '@/styles/v2/vars.css'

function MyApp({ Component, pageProps }): JSX.Element {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      ga.pageview(url)
    }
    //When the component is mounted, subscribe to router changes
    //and log those page views
    router.events.on('routeChangeComplete', handleRouteChange)

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  const renderComponent = () => {
    if (Component.getLayout) {
      return Component.getLayout(<Component {...pageProps} />)
    }
    return <Component {...pageProps} />
  }

  return (
    <>
      <NextNProgress
        color={`${vars.colors.pink.primary}`}
        options={{ showSpinner: false }}
        transformCSS={(css) => {
          // css is the default css string.
          // We're overriding the z-index to account for the mobile header.
          const newCss = css.replace(
            /z-index\s*:\s*9999\s*;/g,
            'z-index: 11000001;'
          )

          return <style>{newCss}</style>
        }}
      />
      <AppProviders {...pageProps}>{renderComponent()}</AppProviders>
    </>
  )
}

export default MyApp
// creatorland-prod.us.auth0.com
